import { Info, useIntl } from '@capsicum/common';
import { Button, Image } from '@capsicum/common-web';
import { type AmlPepWarningModalProps } from '@capsicum/features/regulations/shared';

import * as S from './AmlQuestionnaire.styled';

export const PepWarningModal = ({ onConfirm }: AmlPepWarningModalProps) => {
	const { $t } = useIntl();

	return (
		<S.ModalWrapper>
			<Image alt="info-icon" height={126} src={Info} width={145} />
			<S.ModalTitle>{$t('amlQuestionnaire.fifthStep.pepWarningModal.title')}</S.ModalTitle>
			<S.ModalDescription>{$t('amlQuestionnaire.fifthStep.pepWarningModal.description')}</S.ModalDescription>
			<S.ModalButtonWrapper>
				<Button
					testID="aml-questionnaire-pep-warning-modal-button1"
					text={$t('amlQuestionnaire.fifthStep.pepWarningModal.acceptButton')}
					onClick={() => onConfirm(false)}
				/>
				<Button
					color="neutral"
					testID="aml-questionnaire-pep-warning-modal-button2"
					text={$t('amlQuestionnaire.fifthStep.pepWarningModal.cancelButton')}
					variant="text"
					onClick={() => onConfirm(true)}
				/>
			</S.ModalButtonWrapper>
		</S.ModalWrapper>
	);
};
